import { utils } from '../../../helper/utils';

type FormatterValue = string | number | Date;

export const USER_TABLE_CONFIG = {
  SHOP: {
    columns: [
      { id: 'username', label: 'User Name', width: '10%' },
      { id: 'emailAddress', label: 'Email Address', width: '10%' },
      { id: 'firstName', label: 'First Name', width: '10%' },
      { id: 'lastName', label: 'Last Name', width: '10%' },

      // ✅ Shop Code with overflow
      {
        id: 'shopCode',
        label: 'Shop Code',
        width: '10%',
        overflow: true,
      },

      {
        id: 'createTimestamp',
        label: 'Created On',
        dataType: {
          type: 'string' as const,
          formatter: (value: FormatterValue) => utils.dateFormatter.format(new Date(value)),
        },
      },
      {
        id: 'updateTimestamp',
        label: 'Last Updated On',
        dataType: {
          type: 'string' as const,
          formatter: (value: FormatterValue) => utils.dateFormatter.format(new Date(value)),
        },
      },
      { id: 'isActive', label: 'Status', sortDisabled: true },
      { id: 'actions', label: 'Actions', sortDisabled: true },
    ],

    filters: ['username', 'emailAddress', 'fullName', 'shopCode', 'status'],
  },

  NON_SHOP: {
    columns: [
      { id: 'username', label: 'User Name' },
      { id: 'emailAddress', label: 'Email Address' },
      { id: 'firstName', label: 'First Name' },
      { id: 'lastName', label: 'Last Name' },

      { id: 'role', label: 'Role' },

      // ✅ Overflow fields
      { id: 'region', label: 'Region', overflow: true },
      { id: 'cluster', label: 'Cluster', overflow: true },

      {
        id: 'createTimestamp',
        label: 'Created On',
        dataType: {
          type: 'string' as const,
          formatter: (value: string | number | Date) => utils.dateFormatter.format(new Date(value)),
        },
      },
      {
        id: 'updateTimestamp',
        label: 'Last Updated On',
        dataType: {
          type: 'string' as const,
          formatter: (value: string | number | Date) => utils.dateFormatter.format(new Date(value)),
        },
      },
      { id: 'isActive', label: 'Status', sortDisabled: true },
      { id: 'actions', label: 'Actions', sortDisabled: true },
    ],

    filters: ['username', 'emailAddress', 'fullName', 'role', 'region', 'cluster', 'shopCode', 'status'],
  },
};
export const USER_FILTER_CONFIG = {
  SHOP: ['userName', 'email', 'fullName', 'shopCode', 'isActive'],

  NON_SHOP: ['userName', 'email', 'fullName', 'role', 'region', 'cluster', 'shopCode', 'isActive'],
};
